import { __assign, __extends, __spreadArrays } from "tslib";
import React from 'react';
import { Form, FieldArray } from 'formik';
import { withTranslation } from 'react-i18next';
import PollQuestionField from './PollQuestionField';
import PollAnswerField from './PollAnswerField';
import MediaSelector from '../../MediaPopup/MediaSelector';
import { MediaSourceType } from '../../MediaPopup/types';
import Plus from '../../Icons/Plus';
import s from './PollEditPopup.scss';
var PollEditForm = /** @class */ (function (_super) {
    __extends(PollEditForm, _super);
    function PollEditForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            answerIdxMediaManagerShownFor: null,
        };
        _this.lastAnswerIdUsed = 0;
        _this.initialEditorData = [];
        _this.handleEditorLoad = function (index, editorData) {
            var _a = _this.props, answers = _a.answers, setFieldValue = _a.setFieldValue;
            var isLastIndex = index === answers.length - 1;
            _this.initialEditorData[index] = editorData;
            if (isLastIndex) {
                setFieldValue('answers', answers.map(function (answer, idx) { return (__assign(__assign({}, answer), { editorData: _this.initialEditorData[idx] })); }));
            }
        };
        _this.handleEditorChange = function (index) { return function (editorData) {
            var answer = _this.props.answers[index];
            // Editor fires a change event the first time it loads, so we use a specific handler for that.
            // The reason is that if we repeteadly called `setFieldValue` too fast it would create
            // a race condition and some data would not be commited to the form state.
            // This is because while formik's `setFieldValue` is an async function (it calls `setState`),
            // it doesn't return a Promise or allow passing a callback, which means we don't have a
            // good way of knowing when the action has completed.
            // The `handleEditorLoad` function will collect all initial editor data on an array and call
            // `setFieldValue` once it has gathered the data for all answers.
            // This only happens on edit forms, during the first render.
            if (answer.initialEditorData && !answer.editorData) {
                _this.handleEditorLoad(index, editorData);
            }
            else {
                _this.updateAnswerValue(index, { editorData: editorData });
            }
        }; };
        _this.handleOpenMediaManager = function (index) { return function () {
            _this.setState({
                answerIdxMediaManagerShownFor: index,
            });
        }; };
        _this.handleCloseMediaManager = function () {
            _this.setState({
                answerIdxMediaManagerShownFor: null,
            });
        };
        _this.updateAnswerValue = function (index, value) {
            var _a = _this.props, answers = _a.answers, setFieldValue = _a.setFieldValue;
            setFieldValue('answers', __spreadArrays(answers.slice(0, index), [
                __assign(__assign({}, answers[index]), value)
            ], answers.slice(index + 1)));
        };
        _this.lastAnswerIdUsed = props.answers[props.answers.length - 1].id;
        return _this;
    }
    PollEditForm.prototype.render = function () {
        var _this = this;
        var _a = this.props, answers = _a.answers, setFieldValue = _a.setFieldValue, t = _a.t;
        var answerIdxMediaManagerShownFor = this.state.answerIdxMediaManagerShownFor;
        return (React.createElement(Form, null,
            React.createElement(PollQuestionField, { name: "question", label: t('poll.addYourQuestion'), onChange: function (value) { return setFieldValue('question', value); } }),
            React.createElement(FieldArray, { name: "answers", render: function (_a) {
                    var push = _a.push, remove = _a.remove;
                    return (React.createElement("div", { className: "answers-list" },
                        answers.map(function (answer, index) { return (React.createElement(PollAnswerField, { key: answer.id, index: index, answer: answer, canRemove: answers.length > 2, onChange: _this.handleEditorChange(index), onImageClick: _this.handleOpenMediaManager(index), onRemoveClick: function () { return remove(index); } })); }),
                        answers.length < 10 && (React.createElement("div", { className: s['add-answer-button'], onClick: function () { return push({ id: ++_this.lastAnswerIdUsed }); } },
                            React.createElement(Plus, { className: s['plus-icon'] })))));
                } }),
            answerIdxMediaManagerShownFor !== null && (React.createElement(MediaSelector, { mediaSourceTypes: [MediaSourceType.GALLERY, MediaSourceType.STASH], onClose: this.handleCloseMediaManager, onSelect: function (items) {
                    var selectedDeviation = items[0]; // TODO: this should be done by MS
                    _this.updateAnswerValue(answerIdxMediaManagerShownFor, {
                        deviation: selectedDeviation,
                    });
                    _this.handleCloseMediaManager();
                } }))));
    };
    return PollEditForm;
}(React.Component));
export default withTranslation()(PollEditForm);
//# sourceMappingURL=PollEditForm.js.map